import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "as", "casing", "children", "color", "size", "subheading", "truncateHeading"];
import React, { forwardRef } from 'react';
import theme from '../theme.config';
import { ClearSlots, useSlotProps } from '../../utils/slots';
import { domProps, mergeProps } from '../../utils';
var headingCss = theme.css({
  fontFamily: '$headerFont',
  color: '$heading-text',
  margin: 0,
  variants: {
    size: {
      '1': {
        fontSize: '$h1',
        fontWeight: '$h1',
        lineHeight: '$h1'
      },
      '2': {
        fontSize: '$h2',
        fontWeight: '$h2',
        lineHeight: '$h2'
      },
      '3': {
        fontSize: '$h3',
        fontWeight: '$h3',
        lineHeight: '$h3'
      },
      '4': {
        fontSize: '$h4',
        fontWeight: '$h4',
        lineHeight: '$h4'
      },
      '5': {
        fontSize: '$h5',
        fontWeight: '$h5',
        lineHeight: '$h5'
      },
      '6': {
        fontSize: '$h6',
        fontWeight: '$h6',
        lineHeight: '$h6'
      }
    },
    casing: {
      uppercase: {
        textTransform: 'uppercase'
      }
    },
    color: {
      green: {
        color: '$heading-green'
      },
      blue: {
        color: '$heading-blue'
      }
    }
  }
});
var subheadingCss = theme.css({
  color: '$subheading-text',
  fontSize: '$subheading',
  fontWeight: '$subheading',
  lineHeight: '$subheading',
  marginTop: '$100'
});
var alignCss = theme.css({
  variants: {
    align: {
      center: {
        display: 'block',
        textAlign: 'center'
      },
      left: {
        display: 'block',
        textAlign: 'left'
      },
      right: {
        display: 'block',
        textAlign: 'right'
      }
    }
  }
});
var EzHeading = forwardRef(function (_ref, ref) {
  var _el$props$className;
  var align = _ref.align,
    as = _ref.as,
    casing = _ref.casing,
    title = _ref.children,
    color = _ref.color,
    size = _ref.size,
    subtitle = _ref.subheading,
    truncateHeading = _ref.truncateHeading,
    additionalProps = _objectWithoutProperties(_ref, _excluded);
  var HeadingLevel = as || "h".concat(size);
  var slotProps = useSlotProps({}, 'heading');
  var headingElement = React.createElement(HeadingLevel, {
    className: headingCss({
      size: size,
      casing: casing,
      color: color
    }),
    title: truncateHeading ? title : undefined
  }, React.createElement(ClearSlots, null, title));
  var subheadingElement = subtitle && (size === '3' || size === '5') && React.createElement("div", {
    className: subheadingCss(),
    title: truncateHeading ? subtitle : undefined
  }, React.createElement(ClearSlots, null, subtitle));
  var wrapperElement = React.createElement("div", null, headingElement, subheadingElement);
  var el = subheadingElement ? wrapperElement : headingElement;
  var props = domProps(slotProps, alignCss({
    align: align
  }));
  return React.cloneElement(el, mergeProps(props, additionalProps, {
    ref: ref,
    className: EzHeading['__internalComponentSelector']
  }, {
    className: (_el$props$className = el.props.className) === null || _el$props$className === void 0 ? void 0 : _el$props$className.toString()
  }));
});
EzHeading['__internalComponentSelector'] = 'css-ezh';
EzHeading.displayName = 'EzHeading';
export default EzHeading;